<template>
  <div class="explanation full row">
    <div class="col-6 pad">
      <div class="top">
        <h3 class="title">
          <slot name="title" />
        </h3>
        <h4 class="headline">
          <slot name="headline" />
        </h4>
        <p class="body">
          <slot name="body" />
        </p>
      </div>
      <div class="links">
        <slot name="links" />
      </div>
    </div>
    <div class="col-4">
      <div class="square">
        <slot name="image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionExplanation'
};
</script>
